import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Calendar } from "react-date-range";
import { getCurrentDay } from "../../../../helpers/utils";

const StaticDateMonth = props => {
  return (
    <StyledCalendarStatic
      name={"static-calendar"}
      id={`drop-down-calendar`}
      ranges={props.state.length > 0 && props.state}
      direction={"vertical"}
      inputRanges={["startOfDay"]}
      date={props.date}
      styledStyle={{
        ...props.style,
        ...props.customStyle,
      }}
      hasCustomRendering={true}
      showDateDisplay={false} // Hide date display
      onShownDateChange={item => props.onChange(item)} // Month / Years to
      showPreview={false}
      minDate={new Date("2017-01-01")}
      maxDate={new Date(getCurrentDay())}
    />
  );
};

const StyledCalendarStatic = styled(Calendar)`
  position: absolute;
  z-index: 999999;
  left: ${options => (options.styledStyle.right > 1000 ? "auto" : "0")};
  right: ${options => (options.styledStyle.right > 1000 ? "0" : "auto")};
  border: 1px solid rgba(0, 0, 0, 0.1);
  top: ${options =>
    options.styledStyle.bottom < 400
      ? options.styledStyle?.top
        ? options.styledStyle?.top
        : "75px"
      : options.styledStyle.width < 1700
      ? "-46px"
      : "-46px"};
  border-radius: 5px 0px 5px 5px;

  .rdrMonthAndYearWrapper {
    .rdrMonthAndYearPickers {
      .rdrYearPicker {
        select {
        }
      }
    }
  }

  .rdrMonthsVertical {
    flex-direction: column;
    display: none;
  }

  &::after {
    content: "";
    ${"" /* top: -13px; */}
    top: ${options =>
      options.styledStyle.bottom < 400
        ? "-13px"
        : options.styledStyle.width < 1700
        ? "61px"
        : "61px"};
    transform: ${options =>
      options.styledStyle.bottom < 400 ? "rotate(0deg)" : "rotate(180deg)"};
    left: ${options => (options.styledStyle.right > 1000 ? "auto" : "3px")};
    right: ${options => (options.styledStyle.right > 1000 ? "3px" : "auto")};
    position: absolute;
    border: 6px solid transparent;
    border-bottom: 6px solid rgba(0, 0, 0, 0.1);
  }
`;

StaticDateMonth.propTypes = {
  style: PropTypes.object,
  state: PropTypes.any,
  date: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  toggle: PropTypes.func,
  customStyle: PropTypes.any,
};

export default StaticDateMonth;
